import React from "react";

function Footer() {
  return (
    <div className="footer">
      * Imagens meramente ilustrativas // Todos os direitos reservados.
    </div>
  );
}

export default Footer;
